import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
})
export class ProgressBarComponent {
  public static readonly VARIANTS: Variants = [
    'indeterminate',
    ['indeterminate', 'fixed', 'light', 'automated-actions'],
  ];
  @ComponentVariant(ProgressBarComponent.VARIANTS)
  @Input()
  public variant: string;
}
